import { useId } from 'react';

/**
 * The "Female player" gender chip — magenta gradient square with a ♀ symbol.
 * Colors are baked in by design (Figma Gender component, variant "Female").
 */
export default function GenderFemale({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `gender-female-gradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE6DCC" />
          <stop offset="1" stopColor="#F260B6" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="28" height="28" rx="3.6" fill={`url(#${gradientId})`} />
      <path
        transform="translate(8.57 4.749) scale(1.3333)"
        fill="#FCF2FF"
        d="M0 5.7525C0 2.57548 2.57548 0 5.7525 0C8.92952 0 11.505 2.57548 11.505 5.7525C11.505 8.64515 9.36994 11.0391 6.58973 11.4445C6.54002 11.4518 6.5025 11.4941 6.5025 11.5444V12.425C6.5025 12.4802 6.54727 12.525 6.6025 12.525H8.25C8.66421 12.525 9 12.8608 9 13.275C9 13.6892 8.66421 14.025 8.25 14.025H6.6025C6.54727 14.025 6.5025 14.0697 6.5025 14.125V15.75C6.5025 16.1642 6.16671 16.5 5.7525 16.5C5.33829 16.5 5.0025 16.1642 5.0025 15.75V14.125C5.0025 14.0697 4.95773 14.025 4.9025 14.025H3.255C2.84078 14.025 2.505 13.6892 2.505 13.275C2.505 12.8608 2.84078 12.525 3.255 12.525H4.9025C4.95773 12.525 5.0025 12.4802 5.0025 12.425V11.5444C5.0025 11.4941 4.96498 11.4518 4.91527 11.4445C2.13506 11.0391 0 8.64515 0 5.7525ZM5.7525 1.5C3.40391 1.5 1.5 3.40391 1.5 5.7525C1.5 8.10109 3.40391 10.005 5.7525 10.005C8.10109 10.005 10.005 8.10109 10.005 5.7525C10.005 3.40391 8.10109 1.5 5.7525 1.5Z"
      />
    </svg>
  );
}
